import request from '@utils/request'
import { ParamsProps, ReturnType } from './types'

const find = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `users/${args?.id}`,
      method: 'get',
      authorization: true,
      config: {
        showErr: true,
        store: {
          key: args?.state,
          action: 'set',
        },
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err)
  }
}

const list = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `users`,
      method: 'get',
      params: args?.params,
      authorization: true,
      config: {
        showErr: true,
      },
    }

    if (args.state) {
      config.config.store = {
        key: args?.state,
        action: 'set',
      }
    }
    const response = await request(config)
    return response
  } catch (error) {
    throw new Error(error)
  }
}

const update = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `users/${args?.id}`,
      method: 'patch',
      data: args?.data,
      authorization: true,
      config: {
        successMsg: 'updated Successfully',
        showErr: true,
        store: {
          key: args?.state,
          action: 'update',
        },
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err)
  }
}
const fineOrWarn = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `fines`,
      method: 'post',
      data: args?.data,
      authorization: true,
      config: {
        successMsg: 'Success',
        showErr: true,
        store: {
          key: args?.state,
          action: 'update',
        },
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err)
  }
}
const findfineorwarn = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `fines`,
      method: 'get',
      authorization: true,
      params: args?.params,
      config: {
        showErr: true,
        store: {
          key: args?.state,
          action: 'set',
        },
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err)
  }
}
export default { find, list, update, fineOrWarn, findfineorwarn }
